import { ActionsUnion, createAction } from "@redux/helpers";
import {
  DelFavoritesStylingPayload,
  FavoritesStylingData,
  FavoritesStylingPayload,
  PostFavoritesStylingPayload,
  StylingWishlistData
} from "@type/index";

export const GET_FAVORITES_STYLING =
  "[favorites styling] get favorites styling request";
const GET_FAVORITES_STYLING_SUCCESS =
  "[favorites styling] get favorites styling success";
const GET_FAVORITES_STYLING_LOADING =
  "[favorites styling] get favorites styling loading";
export const POST_FAVORITES_STYLING =
  "[favorites styling] post favorites styling request";
const FAVORITES_STYLING_POST_SUCCESS =
  "[favorites styling] favorites styling post success";
export const DELETE_FAVORITES_STYLING =
  "[favorites styling] del favorites styling request";
const FAVORITES_STYLING_DELETE_SUCCESS =
  "[favorites styling] favorites styling delete success";
const INIT_FAVORITES_STYLING = "[favorites styling] init favorites styling";

export const Actions = {
  getFavoritesStyling: (payload: FavoritesStylingPayload) =>
    createAction(GET_FAVORITES_STYLING, payload),
  getFavoritesStylingSuccess: (payload: FavoritesStylingData) =>
    createAction(GET_FAVORITES_STYLING_SUCCESS, payload),
  getFavoritesStylingLoading: (payload: boolean) =>
    createAction(GET_FAVORITES_STYLING_LOADING, payload),
  postFavoritesStyling: (payload: PostFavoritesStylingPayload) =>
    createAction(POST_FAVORITES_STYLING, payload),
  postFavoritesStylingSuccess: (payload: string) =>
    createAction(FAVORITES_STYLING_POST_SUCCESS, payload),
  delFavoritesStyling: (payload: DelFavoritesStylingPayload) =>
    createAction(DELETE_FAVORITES_STYLING, payload),
  delFavoritesStylingSuccess: (payload: string) =>
    createAction(FAVORITES_STYLING_DELETE_SUCCESS, payload),
  initFavoritesStyling: (payload?: string) =>
    createAction(INIT_FAVORITES_STYLING, payload) // payload=top => official top styling, payload="" => official detail styling
};

type ActionType = ActionsUnion<typeof Actions>;

export type State = StylingWishlistData;

const initialState = {
  stylingLoading: true,
  stylingSBWishlist: [],
  stylingSHWishlist: []
};

export default (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case GET_FAVORITES_STYLING_SUCCESS: {
      const set = new Set([...state.stylingSBWishlist, ...action.payload]);
      const arr = Array.from(set);
      return {
        ...state,
        stylingSBWishlist: [...arr],
        stylingLoading: false
      };
    }
    case GET_FAVORITES_STYLING_LOADING:
      return {
        ...state,
        stylingLoading: action.payload
      };
    case INIT_FAVORITES_STYLING:
      return {
        ...state,
        stylingSBWishlist: []
      };
    case FAVORITES_STYLING_POST_SUCCESS: {
      const styleId = action.payload;
      const newStyleId = state.stylingSBWishlist.filter(
        (item) => item === `${styleId}`
      );
      const styleIds = newStyleId.length
        ? state.stylingSBWishlist
        : [...state.stylingSBWishlist, styleId];
      return {
        ...state,
        stylingLoading: false,
        stylingSBWishlist: [...styleIds]
      };
    }
    case FAVORITES_STYLING_DELETE_SUCCESS: {
      const styleId = action.payload;
      const styleIds = [...state.stylingSBWishlist];
      if (styleIds.includes(styleId)) {
        styleIds.splice(styleIds.indexOf(styleId), 1);
      }
      return {
        ...state,
        stylingLoading: false,
        stylingSBWishlist: [...styleIds]
      };
    }
    default:
      return state;
  }
};
